<template>
  <div>
    <v-card class="login-card">
      <img src="@/assets/logoFta.png" alt="FTA" class="logo" />
      <div v-if="isPreprod" class="preprod-banner">PREPROD</div>

      <!-- Login form -->
      <div v-if="!display">
        <v-text-field
          v-model="user.email"
          outlined
          dense
          label="Identifiant"
          placeholder=" "
          type="email"
          prepend-inner-icon="mdi-account-outline"
          class="mb-2"
          hide-details="auto"
          :rules="[rules.email]"
          data-cy="email-field"
        />

        <v-text-field
          v-model="user.password"
          outlined
          dense
          label="Mot de passe"
          placeholder=" "
          :type="showPassword ? 'text' : 'password'"
          prepend-inner-icon="mdi-lock-outline"
          :append-icon="showPassword ? 'mdi-eye-off' : 'mdi-eye'"
          hide-details="auto"
          :rules="[rules.required]"
          @click:append="showPassword = !showPassword"
          data-cy="password-field"
        />

        <div class="forgot-row">
          <button type="button" class="btn-link" @click="display = true; $emit('clear-err')">
            Mot de passe oublié ?
          </button>
        </div>

        <p v-if="err.length > 0" class="error-msg" data-cy="error-msg">
          {{ normalizeError(err[0]) }}
        </p>

        <v-btn
          block
          depressed
          rounded
          dark
          class="btn-login"
          data-cy="submit-btn"
          @click="$emit('login')"
        >
          Se connecter
        </v-btn>
      </div>

      <!-- Forgot password form -->
      <div v-else>
        <p class="forgot-intro">
          Saisissez votre adresse email ci-dessous pour recevoir un nouveau mot de passe.
        </p>

        <v-text-field
          v-model="user.email"
          outlined
          dense
          label="Adresse email"
          placeholder=" "
          type="email"
          prepend-inner-icon="mdi-email-outline"
          hide-details="auto"
          :rules="[rules.email]"
        />

        <p v-if="successMessage" class="success-msg mt-3">{{ successMessage }}</p>
        <p v-if="err.length > 0" class="error-msg mt-2">{{ err[0] }}</p>

        <div class="forgot-actions mt-4">
          <button type="button" class="btn-link" @click="display = false; err = []">
            Annuler
          </button>
          <v-btn depressed rounded dark class="btn-login btn-login--sm" @click="lostPassword">
            Continuer
          </v-btn>
        </div>
      </div>
    </v-card>

    <div class="barre-bleue" />
  </div>
</template>

<script>
import api from "../../api/user";

export default {
  name: "FormAuth",
  props: ["user", "err"],
  data() {
    return {
      display: false,
      showPassword: false,
      successMessage: "",
      rules: {
        email: (v) => !!(v || "").match(/@/) || "Merci d'indiquer votre mail",
        required: (v) => !!v || "Merci d'indiquer votre mot de passe",
      },
    };
  },
  computed: {
    isPreprod() {
      return process.env.VUE_APP_ENV === 'preprod';
    },
  },
  methods: {
    normalizeError(msg) {
      if (!msg) { return ""; }
      if (msg === "mauvais identifiant / mot de passe") {
        return "L'identifiant ou le mot de passe est incorrect";
      }
      return msg;
    },
    lostPassword() {
      api.lostPassword(this.user)
        .then(() => {
          this.successMessage = "Si cette adresse est connue, un lien de réinitialisation vous a été envoyé.";
          setTimeout(() => {
            this.display = false;
            this.successMessage = "";
          }, 4000);
        })
        .catch(() => {
          this.successMessage = "Si cette adresse est connue, un lien de réinitialisation vous a été envoyé.";
          setTimeout(() => {
            this.display = false;
            this.successMessage = "";
          }, 4000);
        });
    },
  },
};
</script>

<style scoped lang="scss">
.login-card {
  padding: 32px 28px 24px;
  border-radius: 20px 20px 0 0 !important;
}

.logo {
  display: block;
  width: 70%;
  margin: 0 auto 28px;
}

.forgot-row {
  display: flex;
  justify-content: flex-end;
  margin: 6px 0 14px;
}

.btn-link {
  background: none;
  border: none;
  padding: 0;
  color: #004196;
  font-size: 0.8rem;
  text-decoration: underline;
  cursor: pointer;

  &:hover {
    color: #0b87ba;
  }
}

.btn-login {
  background-color: #ff9900 !important;
  letter-spacing: 0.03em;
  padding: 0 32px !important;
  margin-top: 8px;

  &--sm {
    margin-top: 0;
  }
}

.error-msg {
  color: #e53935;
  font-size: 0.78rem;
  margin: 6px 0 8px;
}

.success-msg {
  color: #3ec487;
  font-size: 0.82rem;
}

.forgot-intro {
  font-size: 0.82rem;
  color: #444;
  margin-bottom: 16px;
  line-height: 1.5;
}

.forgot-actions {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.preprod-banner {
  text-align: center;
  background: #ff6f00;
  color: #fff;
  font-size: 0.7rem;
  font-weight: 800;
  letter-spacing: 0.12em;
  padding: 4px 0;
  border-radius: 6px;
  margin-bottom: 20px;
}

.barre-bleue {
  background-color: #2887b9;
  height: 9px;
  box-shadow: 0 8px 0 #c2d8df;
  border-radius: 0 0 6px 6px;
}

::v-deep .v-label {
  color: #004196 !important;
}

::v-deep .v-input--is-focused fieldset {
  border-color: #0b87ba !important;
}
</style>
